const account_center = {
    not_enabled: 'ยังไม่ได้เปิดใช้งานศูนย์บัญชี',
    field_not_editable: 'ไม่สามารถแก้ไขฟิลด์ได้',
    field_not_enabled: 'ฟิลด์ยังไม่ได้เปิดใช้งาน',
};
export default Object.freeze(account_center);
